module.exports = __webpack_public_path__ + "img/map.5362c6bb.svg";